import { type WorkInProgressStatementId } from "@inrev/common";

export const adminWipStatementAttachmentsQueryKey = (wipStatementId: WorkInProgressStatementId) =>
	["adminWipStatementAttachments", wipStatementId] as const;
